import {useNavigate} from "react-router-dom";
import {kInternalRoutes} from "../../../constants/internalRoutes";

export default function HomeSupportProjectButton() {
    // Used in SystemScreenTopBar to display help us button
    // when top bar is displayed in HomeScreen

    // PROPERTIES
    const navigate = useNavigate();

    // BUILD
    return (
        <div className={"cursor-pointer bg-white flex justify-center items-center space-x-[6px] md:space-x-[8px] whitespace-nowrap px-[10px] py-[6px] border-white border-[1px] rounded-[12px] transition-all duration-150 hover:shadow-[0_0_12px_3px_rgba(255,255,255,0.4)] ml-[16px]"}
             onClick={() => navigate(kInternalRoutes.support)}>
            <div className={`animate-appear h-[20px] md:h-[24px] min-h-[20px] md:min-h-[24px] max-h-[20px] md:max-h-[24px] w-[22px] md:w-[26px] min-w-[22px] md:min-w-[26px] max-w-[26px] md:max-w-[26px]`}>
                <img className={"object-contain h-full"}
                     src={'/images/SystemFoxIcon.png'}
                     alt="Flash logo" />
            </div>
            <span className={'text-primaryDark6 font-semibold font-playwrite text-[14px] md:text-[16px]'}>
                {"Nous soutenir"}
            </span>
        </div>
    );
}